import { format } from 'date-fns';
import { safeFormat } from '@/lib/safeDate';
import { ptBR } from 'date-fns/locale';
import { DEMAND_TYPE_CONFIG } from '@/hooks/useSupportInbox';
import { Separator } from '@/components/ui/separator';
import { cn } from '@/lib/utils';
import type { DemandType } from '@/types/support.types';

interface SessionDividerProps {
  sessionId: string;
  demandType: string | null;
  createdAt: string;
  isCurrentSession?: boolean;
  isHighlighted?: boolean;
  status?: string;
  resolutionNotes?: string | null;
}

export function SessionDivider({ 
  sessionId, 
  demandType, 
  createdAt, 
  isCurrentSession,
  isHighlighted,
  status,
  resolutionNotes,
}: SessionDividerProps) {
  const label = demandType && DEMAND_TYPE_CONFIG[demandType as DemandType]
    ? DEMAND_TYPE_CONFIG[demandType as DemandType].label
    : status === 'pre_ticket'
      ? 'Pré-chamado'
      : 'Chamado';
    
  const dateFormatted = safeFormat(new Date(createdAt), "dd/MM 'às' HH:mm", { locale: ptBR });

  return (
    <div 
      id={`session-${sessionId}`}
      className={cn("flex items-center gap-3 my-4 relative scroll-mt-24", status === 'resolved' && resolutionNotes && "mb-8")}
    >
      <Separator className="flex-1" />
      <span className={cn(
        "text-xs px-3 py-1 rounded-full whitespace-nowrap transition-all",
        isCurrentSession 
          ? "bg-primary/10 text-primary font-medium" 
          : "bg-muted text-muted-foreground",
        isHighlighted && "ring-2 ring-primary/50 bg-primary/15 text-primary font-medium"
      )}>
        {label} • {dateFormatted}
      </span>
      <Separator className="flex-1" />
      {status === 'resolved' && resolutionNotes && (
        <div className="absolute -bottom-6 left-1/2 -translate-x-1/2 max-w-[80%]">
          <span className="text-[11px] italic text-muted-foreground bg-muted/50 px-2 py-0.5 rounded">
            {resolutionNotes}
          </span>
        </div>
      )}
    </div>
  );
}
